

























import {Vue, Component, Prop} from 'vue-property-decorator'
import {templateStore} from '@/store'
import {SceneTemplate} from '@/store/templates'
import {SceneShot} from '@/store/shots'
import SceneTemplateChooser from '@/components/NGL/SceneTemplateChooser.vue'
import VuePerfectScrollbar from "vue-perfect-scrollbar"

@Component({
  name: 'SceneTemplateDialog',
  components: {SceneTemplateChooser, VuePerfectScrollbar},
})
export default class SceneTemplateDialog extends Vue {
  @Prop()
  shot!: SceneShot

  dialogOpen = false
  selected: SceneTemplate | null = null

  private init() {
    if (this.shot.sceneTemplateId) {
      const template = templateStore.templates.find((t: SceneTemplate) => t.id === this.shot.sceneTemplateId)
      if (template)
        this.selected = template
    }
  }

  async mounted() {
    await templateStore.loadSceneTemplates()
    this.init()
  }

  dialogToggle() {
    this.dialogOpen = !this.dialogOpen
    if (this.dialogOpen)
      this.init()
  }

  selectTemplate(template: SceneTemplate) {
    this.selected = template
  }

  async applyTemplate() {
    if (this.selected) {
      this.dialogToggle()
      this.$emit('reloadSceneTemplate', this.selected)
    }
  }

  async selectAndApplyTemplate(template: SceneTemplate) {
    this.selectTemplate(template)
    await this.applyTemplate()
  }
}
